import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Paper} from '@material-ui/core';
import { AlertList } from './AlertList';
import { AlertFilter } from './AlertFilter';


class AlertPanel_ extends React.Component {

    constructor() {
        super()

        const time = new Date()
        const date = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0 )

        this.state = {
            filter: {
                dateFrom: date,
                dateTo: null
            },
            alerts: []
        }

        this.handleFilterChange = this.handleFilterChange.bind(this)

        this.handleQueryComplete = this.handleQueryComplete.bind(this)
        this.handeQueryError = this.handeQueryError.bind(this)
        this.handleAction = this.handleAction.bind(this)
    }
    
    componentDidMount(){
        this.handleFilterChange(this.state.filter)
    }

    handleFilterChange(filter){
        this.setState({filter: filter})
        console.log('filter:')
        console.log(filter)

        this.props.alertLogger.queryAlerts(filter, this.handleQueryComplete, this.handeQueryError)
    }

    handleQueryComplete(alerts){
        //alert('query complete')
        console.log('handleQueryComplete')
        console.log(alerts)
        this.setState({alerts: alerts})
    }

    handeQueryError(){
        alert('query error')
    }

    handleAction(action){

    }


    render(){

        return(
            <Paper>
                <AlertFilter onChange={this.handleFilterChange} filter={this.state.filter} onAction={this.handleAction}/>
                <AlertList alerts={this.state.alerts} />
            </Paper>
        );
            //alertLogger={this.props.alertLogger} filter={this.state.filter}
    }

}

export const AlertPanel = withTranslation()(AlertPanel_);